import { render, staticRenderFns } from "./DerbyTemplateList.vue?vue&type=template&id=5c2f925e&scoped=true&"
import script from "./DerbyTemplateList.vue?vue&type=script&lang=js&"
export * from "./DerbyTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f925e",
  null
  
)

export default component.exports